import { useParams, Navigate } from "react-router-dom";
import SIPApp from "./sip/SIPApp";
import HIPApp from "./hip/HIPApp";
import WIPApp from "./wip/WIPApp";

export default function ApplicationPage() {
  const { appSlug } = useParams<{ appSlug: string }>();

  // Route to the correct application based on slug
  switch (appSlug) {
    case "sip":
      return <SIPApp appSlug={appSlug} />;
    case "hip":
      return <HIPApp appSlug={appSlug} />;
    case "wip":
      return <WIPApp appSlug={appSlug} />;
    default:
      // Redirect to home for unknown apps
      return <Navigate to="/" replace />;
  }
}
